export const CHANGE_PAYMENT_METHOD_POLLING_INTERVAL = 1000;
export const CHANGE_PAYMENT_POLLING_ENABLED_FOR = 30000;
export const BULK_UPDATE_POLLING_INTERVAL = 1000;
export const BULK_UPDATE_POLLING_ENABLED_FOR = 30000;
export const BULK_UPDATE_LOCAL_STORAGE_KEY_PREFIX = 'inBulkUpdate_';
